/**
 * Keeps browsers and password managers (iCloud Passwords, 1Password, LastPass, Bitwarden, Chrome) off
 * every field that is not a credential: scan bars, searches, patient data, results. Abraham,
 * 2026-11-02: "los navegadores no deben sugerir iCloud passwords o passwords autocomplete ahí".
 * Only Login / SetPassword / the user form ask for `username` / `*-password`, which pass through.
 */
export const NO_AUTOFILL = {
  autoComplete: "off",
  "data-1p-ignore": "true",
  "data-lpignore": "true",
  "data-bwignore": "true",
  "data-form-type": "other",
} as const;

const CREDENTIAL = /^(username|email|current-password|new-password|one-time-code)$/;

/** Props for an input: the caller's credential `autoComplete` wins; anything else gets NO_AUTOFILL. */
export function autofillProps(autoComplete: string | undefined): Record<string, string> {
  return autoComplete && CREDENTIAL.test(autoComplete) ? { autoComplete } : { ...NO_AUTOFILL };
}
